import {
  FAQS,
  PRE_PURCHASE_FAQS_BY_PASS_ID,
  TERMS_AND_CONDITIONS_BY_PASS_ID,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const pass_bundles: TTeamConfig = {
  TEAM_SCHEMA: "pass_bundles",
  TEAM_FULL_NAME: "Sacramento Kings",
  BROWSER_TITLE: "Sacramento Kings",
  CLIENT_ID: "6b6c129ee955.seasonshare.sackings-sackings.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#5b2c81",
    COLORS_SECONDARY: "#63727A",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.offers,

    NAV_MENU: {
      HIDE_EARN_REWARDS: false,
    },
  },

  BUNDLE_PAGE_SETTINGS: {
    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  BUNDLE_DETAILS_PAGE_SETTINGS: {
    PASS: {
      SHOW_FAQ_BUTTON: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    HIDE_PASSES: false,
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      HIDE_PASS_DETAILS: true,
    },
    SHOW_ALL_PASSES_UNDER_BANNER: true,
    HIDE_UPCOMING_EVENTS: true,

    STATIC_BANNER: {
      IS_ENABLED: false,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    PASS: {
      SHOW_FAQ_BUTTON: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    SHOW_MULTIPLE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
      ADDITIONAL_DETAILS: {
        ADDITIONAL_DETAILS_LABEL: "Additional Details",
      },
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NCAA/Kings-Primary-Color_Logo.png",
    LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/Kings%202025%20Program%20Assets/Kings%20Pass%20-%20Attend%20Desktop%20-%201920x450.jpg",
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/Kings%202025%20Program%20Assets/Kings%20Pass%20-%20Attend%20Mobile%20-%20375x550.jpg",
    MOBILE_BUNDLE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/Kings%202025%20Program%20Assets/Kings%20Pass%20-%20Attend%20Mobile%20-%20375x550.jpg",
    GROUP_INVITE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/Kings%202025%20Program%20Assets/Kings%20Pass%20-%20Attend%20Desktop%20-%201920x450.jpg",
    BUNDLE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202025/Kings%202025%20Program%20Assets/Kings%20Pass%20-%20Attend%20Desktop%20-%201920x450.jpg",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA 2024-25/kings-v3-assets/BACKGROUND IMAGE_1.jpg",
  },

  LANGUAGES: {
    FAQS,
    PRE_PURCHASE_FAQS_BY_PASS_ID,
    TERMS_AND_CONDITIONS_BY_PASS_ID,
  },
};
